import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Grid, MenuItem, Select } from "@material-ui/core";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
}));

export default function FormularioGrupo(props) {
  const { register, errors, defaultItem } = props;
  const classes = useStyles();
  const classesTablero = useStylesTablero();
  const options = [
    { idestatus: 9, label: "Activo" },
    { idestatus: 10, label: "Inactivo" },
  ];
  const [value, setValue] = React.useState(options[0]);
  const [inputValue, setInputValue] = React.useState("");

  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid item lg={12} xs={12}>
        <TextField
          error={false}
          defaultValue={defaultItem.ngrupo}
          id="outlined-error-helper-text"
          label="Nombre"
          variant="outlined"
          fullWidth
          name="ngrupo"
          inputRef={register({
            required: {
              value: true,
              message: "Nombre es requerido",
            },
            maxLength: {
              value: 25,
              message: "No más de 25 carácteres!",
            },
            minLength: {
              value: 5,
              message: "Mínimo 5 carácteres",
            },
          })}
          className={classesTablero.field}
        />
        {errors.nombre_persona && (
          <p style={{ color: "red" }}>"Campo requerido" </p>
        )}
      </Grid>
    </Grid>
  );
}
